import { __assign } from "tslib";
import React from 'react';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import DefaultThumb from './Default';
import TierThumb from './Tier';
var MobileThumb = function (props) {
    var type = getDeviationType(props.deviation);
    switch (type) {
        case DeviationTypes.TIER:
            return React.createElement(TierThumb, __assign({}, props));
        default:
            return React.createElement(DefaultThumb, __assign({}, props));
    }
};
MobileThumb.displayName = 'MobileThumb';
export default MobileThumb;
//# sourceMappingURL=Mobile.js.map